import { render, staticRenderFns } from "./WalkInCustomer.vue?vue&type=template&id=058614c8&scoped=true"
import script from "./WalkInCustomer.vue?vue&type=script&lang=js"
export * from "./WalkInCustomer.vue?vue&type=script&lang=js"
import style0 from "./WalkInCustomer.vue?vue&type=style&index=0&id=058614c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058614c8",
  null
  
)

export default component.exports